import React from 'react';
import { IconProps } from './type';

export const ArrowPushDownIcon = ({
  color = 'currentColor',
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        d="M8.10861 10.8079C7.86453 10.5638 7.4688 10.5638 7.22472 10.8079C6.98065 11.052 6.98065 11.4477 7.22472 11.6918L11.9747 16.4418C12.2188 16.6859 12.6145 16.6859 12.8586 16.4418L17.6086 11.6918C17.8527 11.4477 17.8527 11.052 17.6086 10.8079C17.3645 10.5638 16.9688 10.5638 16.7247 10.8079L13.0417 14.491V4.1665C13.0417 3.82133 12.7618 3.5415 12.4167 3.5415C12.0715 3.5415 11.7917 3.82133 11.7917 4.1665V14.491L8.10861 10.8079Z"
        fill={color}
      />
      <path
        d="M4.33594 19.3996C4.33594 19.731 4.60457 19.9996 4.93594 19.9996H20.0719C20.4033 19.9996 20.6719 19.731 20.6719 19.3996C20.6719 19.0683 20.4033 18.7996 20.0719 18.7996H4.93594C4.60457 18.7996 4.33594 19.0683 4.33594 19.3996Z"
        fill={color}
      />
    </svg>
  );
};
